export default __webpack_public_path__ + "static/media/giftbox2-tick.4e92c499.svg";